import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { Sparkles } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.token) localStorage.setItem("token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0E0E12] flex items-center justify-center">
      <div className="text-center text-zinc-400 flex flex-col items-center gap-4">
        <Sparkles className="w-8 h-8 text-orange-400 animate-pulse" />
        <div>Accesso in corso...</div>
      </div>
    </div>
  );
}
